<template>
    <div>
        <page-header :text="$t('invitation.organization_invitation')" />

        <div class="subheader" v-if="organization">
            <h2 class="subheader__headline">
                {{ organization.name }}
            </h2>
        </div>

        <div class="row row--table row--blocks" v-if="organization">
            <div class="column-12">
                <div
                    class="alert alert--success slab-mobile--bottom hide-slide-animation"
                    v-if="responseCode === 201"
                    role="alert"
                >
                    {{ $t('invitation.accepted_alert') }}

                    <router-link :to="'/organization/' + organization.id">
                        {{ $t('invitation.show_organization') }}
                    </router-link>
                </div>

                <div
                    class="alert alert--warning slab-mobile--bottom hide-slide-animation"
                    v-if="responseCode === 200"
                    role="alert"
                >
                    {{ $t('invitation.refused_alert') }}
                </div>
                <div
                    class="alert alert--danger slab-mobile--bottom hide-slide-animation"
                    v-if="responseCode === 400"
                    role="alert"
                >
                    {{ $t('errors.error_occurred') }}
                </div>

                <p v-if="role === 'owner'">
                    {{
                        $t('invitation.for_organization_owner', { organization: organization.name })
                    }}
                </p>
                <p v-if="role === 'admin'">
                    {{ $t('invitation.for_organization_admin') }}
                </p>
                <p v-if="role === 'person'">{{ $t('invitation.for_organization_person') }}</p>

                <p v-if="role === 'technician'">
                    {{ $t('invitation.for_organization_technician') }}
                </p>

                <span v-if="invitedOrganizations && invitedOrganizations.length > 0">
                    <p>{{ $t('invitation.allows_organisations_to_view') }}</p>
                    <ul>
                        <li v-for="o in invitedOrganizations" :key="o.id">
                            {{ o.name }}
                        </li>
                    </ul>
                    <br />
                </span>

                <a
                    @click="accept()"
                    class="button button--success"
                    :class="{
                        'ng-hide': responseCode == 200,
                        disabled: responseCode == 201 || loadingAccept,
                    }"
                >
                    <span v-if="responseCode == 201">{{ $t('invitation.accepted') }}</span>
                    <span v-else>{{ $t('invitation.accept') }}</span>
                </a>

                <span>&nbsp;</span>

                <a
                    @click="refuse()"
                    class="button button--primary"
                    :class="{
                        'ng-hide': responseCode == 201,
                        disabled: responseCode == 200 || loadingRefuse,
                    }"
                >
                    <span v-if="responseCode == 200">{{ $t('invitation.refused') }}</span>
                    <span v-else>{{ $t('invitation.refuse') }}</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import * as api from '@/api';
import PageHeader from '@/components/PageHeader';
import InvitationCheck from '@/helpers/invitations-check';

export default {
    name: 'organization-invitations',
    components: {
        PageHeader,
    },
    data() {
        return {
            role: null,
            organization: null,
            responseCode: null,
            loadingAccept: false,
            loadingRefuse: false,
        };
    },
    computed: {
        invitedOrganizations() {
            if (this.organization) {
                if (this.organization.breadcrumbs && this.organization.breadcrumbs.length > 0) {
                    const baseOrganizationIndex = this.organization.breadcrumbs.findIndex(
                        crumb => crumb.is_base_organization === false
                    );
                    if (baseOrganizationIndex >= 0) {
                        return this.organization.breadcrumbs.slice(baseOrganizationIndex);
                    } else {
                        const breadcrumbAmount = this.organization.breadcrumbs.length;
                        return [this.organization.breadcrumbs[breadcrumbAmount - 1]];
                    }
                }
            }
            return false;
        },
    },
    watch: {
        $route: function() {
            this.resetData();
            this.fetchData();
        },
    },
    created() {
        this.fetchData();
    },
    methods: {
        resetData() {
            this.role = null;
            this.organization = null;
            this.responseCode = null;
            this.loadingAccept = false;
            this.loadingRefuse = false;
        },
        fetchData() {
            api.invitations.get(this.$route.params.invitationId).then(
                response => {
                    this.organization = response.data.inviting_organization;
                    this.role = response.data.permission;
                },
                () => {
                    this.$notify({ type: 'error', text: this.$t('errors.error_occurred') });
                }
            );
        },
        accept() {
            if (this.responseCode === 201) {
                return;
            }

            this.loadingAccept = true;

            api.invitations
                .accept(this.$route.params.invitationId)
                .then(
                    response => {
                        this.responseCode = response.status;
                        InvitationCheck.now();
                    },
                    () => {
                        this.responseCode = 400;
                    }
                )
                .catch()
                .then(() => {
                    this.loadingAccept = false;
                });
        },
        refuse() {
            if (this.responseCode === 200) {
                return;
            }

            this.loadingRefuse = true;

            api.invitations
                .refuse(this.$route.params.invitationId)
                .then(
                    response => {
                        this.responseCode = response.status;
                        InvitationCheck.now();
                    },
                    () => {
                        this.responseCode = 400;
                    }
                )
                .catch()
                .then(() => {
                    this.loadingRefuse = false;
                });
        },
    },
};
</script>
